import { render } from "./devis.vue?vue&type=template&id=bafb4258&scoped=true"
import script from "./devis.vue?vue&type=script&lang=js"
export * from "./devis.vue?vue&type=script&lang=js"

import "./devis.vue?vue&type=style&index=0&id=bafb4258&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafb4258"]])

export default __exports__